import { useAuthStore, useUserTrialDetails } from '@revelio/auth';

const useIsTrialUserWithNoDatasetAccess = () => {
  const { isTrialUser } = useUserTrialDetails();
  const dataSetsWithAccess = useAuthStore((state) => state.dataSets);

  const isTrialUserWithNoDatasetAccess =
    isTrialUser && !dataSetsWithAccess?.length;

  return isTrialUserWithNoDatasetAccess;
};

export default useIsTrialUserWithNoDatasetAccess;
